import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { AttributeContext } from "./AttributeContext";
import AttrList from "./AttrList";
import AddEditViewAttr from "./AddEditViewAttr";
import { AppContext } from "../../../Context/AppContext";
import { toast } from "Components/DesignSystem/Toast/useToast";
import Alert from "Components/DesignSystem/Alert/Alert";
import Spinner from "Components/DesignSystem/Spinner/Spinner";
import Button from "Components/DesignSystem/Button/Button";
import EmptyState from "Components/DesignSystem/EmptyState/EmptyState";
import NoDataIllustration from "Components/DesignSystem/EmptyState/NoDataIllustration";

function AttributeManage(props) {
  const navigate = useNavigate();
  const appData = useContext(AppContext);
  let [attrListApiCompleted, setAttrListApiCompleted] = useState(false);

  const industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const { deleteinfo, editingItem, setEditingItem } =
    useContext(AttributeContext);
  const [reRender, setReRender] = useState(true);
  useEffect(() => {
    if (editingItem && editingItem.id !== 0) setReRender(false);
    setTimeout(() => {
      setReRender(true);
    }, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem && editingItem.id]);
  let AttributeContextData = useContext(AttributeContext);

  useEffect(() => {
    appData.pm.hasPermission(
      "gmsattributes_read",
      { push: navigate },
      "/workspace/module/permission/denied"
    );
    setEditingItem(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId]);
  return (
    <React.Fragment>
      <div className="container-fluid p-0 h-25" data-testid="attributes-page">
        <div className="row mt-0">
          <div className="col-md-3">
            {/* The § 99 status-strip grammar (category Manage precedent): spinner
                inline and aria-hidden — the Alert is the live region, the message
                carries the announcement. Loading/Success are polite `role="status"`;
                only Error is `role="alert"`. */}
            {deleteinfo.status === "Loading" && (
              <Alert tone="info" live data-testid="attribute-delete-status-alert">
                <span className="tw-inline-flex tw-items-center tw-gap-2">
                  <Spinner size="sm" aria-hidden="true" data-testid="attribute-delete-status-spinner" />
                  <span>{deleteinfo.message}</span>
                </span>
              </Alert>
            )}
            {deleteinfo.status === "Success" && (
              <Alert tone="success" live data-testid="attribute-delete-status-alert">
                {deleteinfo.message}
              </Alert>
            )}
            {deleteinfo.status === "Error" && (
              <Alert tone="danger" live data-testid="attribute-delete-status-alert">
                {deleteinfo.message}
              </Alert>
            )}
          </div>
        </div>

        <div className="d-flex flex-wrap relative">
          <div className="col-sm-12 col-md-12 col-lg-2 ps-2 relative md:h-page-content p-0 top-0 tw-border-r-2 tw-border-edge">
            <AttrList
              props={props}
              attrListApiCompleted={attrListApiCompleted}
            />
          </div>
          {editingItem !== null ? (
            <div className="ps-0 pe-0 px-2 col-sm-12 col-md-12 col-lg-10  md:h-page-content md:overflow-y-auto">
              <AddEditViewAttr
                setAttrListApiCompleted={setAttrListApiCompleted}
              />
              {editingItem.id !== "0" && reRender && (
                <div className="" style={{ marginBottom: "50vh" }}></div>
              )}
            </div>
          ) : (
            <div className="col-sm-12 col-md-12 col-lg-10 ps-0 pe-0 ">
              {attrListApiCompleted && (
                <EmptyState
                  size="md"
                  className="mt-5"
                  data-testid="attributes-empty-state"
                  illustration={<NoDataIllustration />}
                  title="No data found"
                  description="You can create attributes."
                  action={
                    <Button
                      variant="secondary"
                      data-testid="attributes-create-btn"
                      onClick={() => {
                        if (
                          appData.pm.checkPermission("gmsattributes_update")
                        ) {
                          if (
                            AttributeContextData.editingItem === null ||
                            AttributeContextData.editingItem.form === "view"
                          ) {
                            AttributeContextData.setEditingItem({
                              form: "edit",
                              id: "0",
                            });
                          } else {
                            AttributeContextData.setEditingItem(null);
                            setTimeout(() => {
                              if (
                                appData.pm.checkPermission(
                                  "gmsattributes_update"
                                )
                              ) {
                                AttributeContextData.setEditingItem({
                                  form: "edit",
                                  id: "0",
                                });
                              } else {
                                toast.info(
                                  "You don't have permission to edit the attribute"
                                );
                              }
                            }, 1000);
                          }
                        } else {
                          toast.info(
                            "You don't have permission to create the attribute"
                          );
                        }
                      }}
                    >
                      Create Attributes
                    </Button>
                  }
                />
              )}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default AttributeManage;
